/*
 * zh-cn locale
 * @ignore
 * @author yiminghe@gmail.com
 */
"use strict";

module.exports = {
  // in minutes
  timezoneOffset: 8 * 60,
  firstDayOfWeek: 0,
  minimalDaysInFirstWeek: 1
};


// WEBPACK FOOTER //
// ./_gregorian-calendar/lib/locale/zh_CN.js